/*
 * Copyright © 2017-2021 Skale Education Inc. - All Rights Reserved
 */

// Alert is a prime candidate for refactoring & improvement, but I'm leaving
// it untouched for now in the interest of just getting things merged & working

export default function Alert(
  title: string,
  description: string,
  options: { text?: string; style?: string; onPress: () => void }[]
) {
  const result = window.confirm(
    [title, description].filter(Boolean).join("\n")
  );

  if (result) {
    const confirmOption =
      options && options.find(({ style }) => style !== "cancel");
    confirmOption && confirmOption.onPress && confirmOption.onPress();
  } else {
    const cancelOption =
      options && options.find(({ style }) => style === "cancel");
    cancelOption && cancelOption.onPress && cancelOption.onPress();
  }
}
